import { createContext, useContext } from 'react';

import { ChatStateProps } from 'src/components/navigation/src/components/index-next';
import {
  RovoChatSidebarApi,
  useRovoChatState,
} from 'src/sections/global/components/chat-sidebar';
import { NavigationFeedbackCollector } from 'src/sections/global/containers/navigation-feedback-collector';
import NavigationKeyboardShortcuts from 'src/sections/global/containers/navigation-keyboard-shortcuts';

import { Layout } from './layout';

export const DEFAULT_ROVO_STATE = {
  isEnabled: false,
  isActive: false,
  siteId: '',
};

export type RovoChatContextType = ChatStateProps & {
  sidebarApi: RovoChatSidebarApi | undefined;
};

export const RovoChatContext = createContext<RovoChatContextType>({
  chatState: DEFAULT_ROVO_STATE,
  setChatState: () => {},
  sidebarApi: undefined,
});

export const useRovoChatContext = () => {
  return useContext(RovoChatContext);
};

// wrapper to include any providers or things that need to live above all nav4 stuff
export function NavSystem() {
  const rovoChatState = useRovoChatState();

  return (
    <RovoChatContext.Provider value={rovoChatState}>
      <NavigationKeyboardShortcuts>
        <Layout />
      </NavigationKeyboardShortcuts>
      <NavigationFeedbackCollector />
    </RovoChatContext.Provider>
  );
}
